import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Language {

  lang_words: Array<any>;

  constructor() {

    this.lang_words = [
      {text_key: "_", text_ar: " ", text_en: " "}, {
        text_key: "home",
        text_ar: "الرئيسية",
        text_en: "Home"
      }, {
        text_key: "login_content",
        text_ar: "سجل دخول الى لوحة التحكم باستخدام البريد الالكتروني وكلمة المرور ",
        text_en: " Log in to the control panel using your email and password "
      }, {text_key: "login", text_ar: " دخول ", text_en: " Login "}, {
        text_key: "password",
        text_ar: " كلمة المرور ",
        text_en: " Password "
      }, {text_key: "email", text_ar: "البريد الالكتروني", text_en: " Email "}, {
        text_key: "sendNotifications",
        text_ar: "ارسال الاشعارات",
        text_en: "Send Notifications "
      }, {text_key: "place", text_ar: "المنطقة", text_en: "Area "}, {
        text_key: "notificationsHistory",
        text_ar: "سجل الاشعارات المرسلة",
        text_en: "notifications History"
      }, {text_key: "to_place", text_ar: "الى موقع", text_en: "To Place"}, {
        text_key: "acceptTime",
        text_ar: "وقت القبول",
        text_en: "Accept Time"
      }, {text_key: "from_place", text_ar: "من موقع", text_en: "From Place"}, {
        text_key: "arrivalTime",
        text_ar: "وقت الوصول",
        text_en: "Arrival Time"
      }, {text_key: "completedTime", text_ar: "وقت اكتمال الرحلة", text_en: "Completed Time"}, {
        text_key: "tripAction",
        text_ar: "الاجراء",
        text_en: "Action "
      }, {text_key: "ex_in", text_ar: "الفكة", text_en: "Exchange"}, {
        text_key: "client_rating",
        text_ar: "تقييم العميل",
        text_en: ""
      }, {text_key: "cash_in", text_ar: "المدفوع", text_en: "Payed "}, {
        text_key: "cant_view_this_item",
        text_ar: "غير مصرح لك بذلك",
        text_en: "You no have access "
      }, {
        text_key: "add_ex_wallet",
        text_ar: "اضافة الفكة للمحفظة",
        text_en: "Add Exchange to wallet "
      }, {text_key: "from_coordinates", text_ar: "نقطة الانطلاق", text_en: "Pickup Point "}, {
        text_key: "cars",
        text_ar: "المركبات",
        text_en: "Cars"
      }, {text_key: "suppliers", text_ar: "الوكلاء", text_en: "Suppliers"}, {
        text_key: "to_coordinates",
        text_ar: "نقطة الوصول",
        text_en: "Drop Point "
      }, {text_key: "customers", text_ar: "العملاء", text_en: "Customers"}, {
        text_key: "trips_and_booking",
        text_ar: "الرحلات والحجوزات",
        text_en: "Trips & Booking"
      }, {
        text_key: "offlineDrivers",
        text_ar: "سائقين اوفلاين",
        text_en: "Offline Drivers"
      }, {text_key: "driver_canceled", text_ar: "الغاها السائق", text_en: "Driver Canceled"}, {
        text_key: "high_traffic",
        text_ar: "منطاق زحام",
        text_en: "High Traffic districts"
      }, {
        text_key: "customer_canceled",
        text_ar: "الغاها العميل",
        text_en: "Customer Canceled"
      }, {
        text_key: "waiting_arrival",
        text_ar: "بانتظار الوصول",
        text_en: "Waiting Arrival"
      }, {
        text_key: "current_without_gps",
        text_ar: "رحلة حالية GPS معطل",
        text_en: "Current GPS Offline "
      }, {text_key: "hourly_active", text_ar: "معدل الناشط بالساعة", text_en: " Hourly Active "}, {
        text_key: "top",
        text_ar: "الافضل",
        text_en: " Top"
      }, {text_key: "weBooking", text_ar: "رحلات وي", text_en: "We Trips"}, {
        text_key: "churn",
        text_ar: "غير فعال",
        text_en: "Churn"
      }, {
        text_key: "total_revenue",
        text_ar: "اجمالي الربح",
        text_en: "Total Revenue"
      }, {
        text_key: "referral_and_referred",
        text_ar: "دعوات الانضمام",
        text_en: "Referral and referred "
      }, {
        text_key: "financeReport",
        text_ar: "التقرير المالي",
        text_en: "Finance Report"
      }, {text_key: "rejected_orders", text_ar: "طلبات مروفضة", text_en: "Rejected Orders"}, {
        text_key: "docExpired",
        text_ar: "انتاء الرخصة",
        text_en: "Document Expired "
      }, {
        text_key: "CarDocExpired",
        text_ar: "انتهاء رخصة المركية",
        text_en: " Car Document Expired "
      }, {
        text_key: "escalation_report",
        text_ar: "تقرير الشكاوي",
        text_en: "Escalation Report "
      }, {
        text_key: "subscriptionReport",
        text_ar: "تقرير الاشتراكات ",
        text_en: "Subscription Report "
      }, {text_key: "commissionReport", text_ar: "تقرير العمولة", text_en: "Commission Report"}, {
        text_key: "districts",
        text_ar: "الاحياء",
        text_en: "Districts"
      }, {text_key: "highDemand", text_ar: "الاكثر زحام", text_en: "High Demand"}, {
        text_key: "payments",
        text_ar: "المدفوعات",
        text_en: "Payments"
      }, {text_key: "onboarding", text_ar: " حالة فحص الاوراق ", text_en: "OnBoarding Status "}, {
        text_key: "rejected",
        text_ar: "مرفوض",
        text_en: "Rejected"
      }, {text_key: "timeRent", text_ar: "ساتا تايم", text_en: "Time Rent "}, {
        text_key: "rent",
        text_ar: "ساتا رينت",
        text_en: "Car Rent"
      }, {text_key: "carMakers", text_ar: "صناع المركبات", text_en: "Cars Makers"}, {
        text_key: "carModels",
        text_ar: "موديلات المركبات",
        text_en: "Cars Models"
      }, {text_key: "usage", text_ar: "معدل الاستخدام", text_en: "Usage Rate"}, {
        text_key: "promo_code",
        text_ar: " كوبون خصم ",
        text_en: " Promo Code "
      }, {text_key: "cash", text_ar: "نقدا", text_en: "Cash"}, {
        text_key: "unused",
        text_ar: "غير مستخدم",
        text_en: "Un Usage Rate "
      }, {text_key: "cards", text_ar: "البطاقات", text_en: "Cards"}, {
        text_key: "hourlyCanceled",
        text_ar: "معدل الالغاء بالساعة",
        text_en: "Hourly Canceled"
      }, {
        text_key: "hourlyCompleted",
        text_ar: "معدل الاتمام بالساعة",
        text_en: "Hourly Completed"
      }, {text_key: "weFulfillment", text_ar: "معدل الاتمام", text_en: " Fulfillment Rate "}, {
        text_key: "utilization",
        text_ar: "معدل القبول",
        text_en: "Utilization Rate"
      }, {
        text_key: "fulfillment",
        text_ar: "معدل الاتمام",
        text_en: " Fulfillment Rate "
      }, {
        text_key: "rentFulfillment",
        text_ar: "معدل الاتمام",
        text_en: " Fulfillment Rate "
      }, {text_key: "rentUtilization", text_ar: "معدل القبول", text_en: "Utilization Rate"}, {
        text_key: "weUtilization",
        text_ar: "معدل القبول",
        text_en: "Utilization Rate"
      }, {text_key: "sataWe", text_ar: " ساتا وي", text_en: " We "}, {
        text_key: "weekly",
        text_ar: "اسبوعي",
        text_en: "Weekly"
      }, {text_key: "monthly", text_ar: "شهري", text_en: "Monthly"}, {
        text_key: "yearly",
        text_ar: "سنوي",
        text_en: "Yearly"
      }, {text_key: "escalation", text_ar: "الشكاوي والبلاغات", text_en: "Escalations "}, {
        text_key: "onboarding_sal",
        text_ar: "سرعة الرد ",
        text_en: "Onboarding SLA "
      }, {text_key: "fastHelp", text_ar: "مساعدة سريعة", text_en: " Fast Help "}, {
        text_key: "critical_tickets",
        text_ar: " طارئة ",
        text_en: " Critical "
      }, {
        text_key: "incomeVsOutcome",
        text_ar: " الدخل مقابل المصروف ",
        text_en: " Income Vs Outcome "
      }, {text_key: "promotions", text_ar: " كوبونات الخصم ", text_en: " Promotions "}, {
        text_key: "new_pormotion",
        text_ar: "كوبون جديد",
        text_en: " New Promotion "
      }, {
        text_key: "pormotion_list",
        text_ar: " قائمة الكوبونات ",
        text_en: " Promotions List "
      }, {
        text_key: "notificationSettings",
        text_ar: " ضبط الاشعارات",
        text_en: " Notifications Settings "
      }, {text_key: "notification", text_ar: "الاشعارات", text_en: " Notifications "}, {
        text_key: "emailSettings",
        text_ar: "اعدادات البريد الالكتروني",
        text_en: " Email Settings "
      }, {
        text_key: "invoiceSettings",
        text_ar: "اعدادات الفاتورة",
        text_en: " Invoice Settings "
      }, {
        text_key: "systemConfiguration",
        text_ar: "اعدادات النظام ",
        text_en: " System Configuration "
      }, {text_key: "workZones", text_ar: "مناطق العمل", text_en: " Work Zones "}, {
        text_key: "generalSettings",
        text_ar: "الاعدادات العامة",
        text_en: " General Settings "
      }, {text_key: "cities", text_ar: " المدن ", text_en: " Cities "}, {
        text_key: "supplierCommissions",
        text_ar: " عمولة الوكلاء ",
        text_en: " Supplier Commissions "
      }, {text_key: "labels", text_ar: " تصنيف الاسباب ", text_en: " Labels "}, {
        text_key: "driverCommissions",
        text_ar: " عمولة السائقين ",
        text_en: " Driver Commissions "
      }, {text_key: "options", text_ar: " الاسباب ", text_en: " Options "}, {
        text_key: "driverCancelOptions",
        text_ar: " اسباب الغاء السائقين ",
        text_en: "Driver Cancel Options"
      }, {
        text_key: "customerCancelOptions",
        text_ar: " اسباب الغاء العملاء ",
        text_en: "Customers Cancel Options "
      }, {text_key: "countries", text_ar: " الدول ", text_en: " Countries "}, {
        text_key: "fuelType",
        text_ar: " نوع الوقود ",
        text_en: "Fuel Type "
      }, {
        text_key: "transmissionType",
        text_ar: " نوع ناقل الحركة ",
        text_en: " Transmission Type "
      }, {text_key: "whiteList", text_ar: " القائمة البيضاء ", text_en: " WhiteList "}, {
        text_key: "blackList",
        text_ar: " القائمة السوداء ",
        text_en: " BlackList "
      }, {
        text_key: "expAlertSettings",
        text_ar: " تنبيهات الانتهاء ",
        text_en: " Expired Alert Settings "
      }, {
        text_key: "raidRejectedOptions",
        text_ar: " اسباء رفض الرحلة ",
        text_en: " Trip Rejected Options "
      }, {
        text_key: "rentRejectedOptions",
        text_ar: "اسباب رفض الايجار ",
        text_en: " Rent Rejected Options "
      }, {
        text_key: "paymentSettings",
        text_ar: " اعدادات الدفع ",
        text_en: " Payments Settings "
      }, {
        text_key: "paymentConfigurations",
        text_ar: " تهيئة المدفوعات ",
        text_en: " Payments Configurations "
      }, {
        text_key: "paymentMethods",
        text_ar: " وسائل الدفع ",
        text_en: " Payments Methods "
      }, {text_key: "notifications", text_ar: " الاشعارات ", text_en: " Notifications "}, {
        text_key: "documentRejected",
        text_ar: " مستندات مرفوضة ",
        text_en: " Document Rejected "
      }, {
        text_key: "documentExp",
        text_ar: " تحتاج الى تجديد ",
        text_en: " Document Expired "
      }, {
        text_key: "documentExpSoon",
        text_ar: " اقتراب تاريخ التجديد ",
        text_en: " Document Expired Soon "
      }, {text_key: "activeLive", text_ar: " نشط ", text_en: " Active "}, {
        text_key: "notActive",
        text_ar: " غير نشط ",
        text_en: " Not Active "
      }, {text_key: "suspend", text_ar: " موقوف ", text_en: " Suspend "}, {
        text_key: "closedAccount",
        text_ar: " مغلق ",
        text_en: " Closed "
      }, {text_key: "deleted", text_ar: " محذوف ", text_en: " Deleted "}, {
        text_key: "importExport",
        text_ar: " استيراد وتصدير البيانات ",
        text_en: " Export & Import Data "
      }, {
        text_key: "databaseExport",
        text_ar: " تصدير جدول البيانات ",
        text_en: " Table DB Export "
      }, {
        text_key: "suppliersLog",
        text_ar: " سجل اجراءات الوكيل ",
        text_en: " Suppliers Log "
      }, {
        text_key: "changePhotoRequest",
        text_ar: " طلب تغيير الصورة ",
        text_en: " Change Photo Request "
      }, {text_key: "subscriptions", text_ar: " مشتركين ", text_en: " Subscriptions "}, {
        text_key: "subscriptionsExp",
        text_ar: " اشتراكات سوف تنتهي ",
        text_en: " Subscriptions Expired "
      }, {text_key: "cashLimit", text_ar: " الحد الاقصي ", text_en: "Cash Limit"}, {
        text_key: "drivers_log",
        text_ar: " سجل اجراءات السائقين",
        text_en: " Drivers Log "
      }, {
        text_key: "changeInfoRequest",
        text_ar: " طلب تغيير معلومات ",
        text_en: " Change Info Request "
      }, {text_key: "cars_log", text_ar: " سجل اجراءات المركبة", text_en: " Cars Log "}, {
        text_key: "temporarySuspend",
        text_ar: " إيقاف مؤقت ",
        text_en: " Temporary Suspend "
      }, {text_key: "customers_log", text_ar: " سجل اجراءات العملاء ", text_en: " Customers log "}, {
        text_key: "solved",
        text_ar: " تم حلها ",
        text_en: " Solved "
      }, {
        text_key: "points_exchange",
        text_ar: "تبديل النقاط ",
        text_en: "Points Exchange "
      }, {
        text_key: "new_promotion",
        text_ar: " بطاقة خصم جديدة ",
        text_en: " New Promotion "
      }, {
        text_key: "promotions_list",
        text_ar: " بطاقات الخصم ",
        text_en: " Promotions list "
      }, {text_key: "screenLocked", text_ar: " شاشة مقفلة ", text_en: " Screen Locked "}, {
        text_key: "adminsLog",
        text_ar: " سجل اجراءات العاملين ",
        text_en: "Admins Log"
      }, {
        text_key: "send_notifications",
        text_ar: " ارسال الاشعارات ",
        text_en: " Send Notifications "
      }, {
        text_key: "notifications_history",
        text_ar: " سجل ارسال الاشعارات",
        text_en: " Notifications History "
      }, {
        text_key: "driversPlan",
        text_ar: " خطط اشتراك السائقين ",
        text_en: " Drivers subscription Plan "
      }, {
        text_key: "buildServiceType",
        text_ar: " انشاء وتكوين الخدمات ",
        text_en: " Build Service Type "
      }, {
        text_key: "createWorkZone",
        text_ar: " انشاء منقطة عمل ",
        text_en: " Create Work Zone "
      }, {
        text_key: "dispatchingRole",
        text_ar: "اعدادات الالتقاط ",
        text_en: " Dispatching Role "
      }, {text_key: "servicePricing", text_ar: " اسعار الخدمات ", text_en: " Service Pricing "}, {
        text_key: "disable",
        text_ar: " معطل ",
        text_en: " Disable "
      }, {text_key: "zonelog", text_ar: " سجل المناطق ", text_en: " Zones log "}, {
        text_key: "createTrip",
        text_ar: " عمل رحلة",
        text_en: " Create Trip "
      }, {text_key: "vehiclesType", text_ar: "نوع المركبة", text_en: " Vehicles Type "},
      {
        text_key: "carsMakers",
        text_ar: "الصانعين",
        text_en: " Cars Makers "
      },
      {
        text_key: "carsmakers",
        text_ar: "الصانعين",
        text_en: " Cars Makers "
      }, {text_key: "carsModels", text_ar: "الموديلات", text_en: " Cars Models "}, {
        text_key: "fuelType",
        text_ar: "نوع الوقود",
        text_en: " Fuel Type "
      }, {text_key: "carsColors", text_ar: "الالوان", text_en: " Cars Colors "}, {
        text_key: "transmissionType",
        text_ar: " ناقل الحركة ",
        text_en: " Transmission Type "
      }, {text_key: "logut", text_ar: "تسجيل خروج", text_en: "Logout"}, {
        text_key: "comments_reviews",
        text_ar: "التعليقات والتقييم",
        text_en: "Reviews "
      }, {
        text_key: "restaurant_comments",
        text_ar: "تعليقات المتاجر",
        text_en: "Stores Reviews "
      }, {text_key: "search_comments", text_ar: "البحث", text_en: "Search"}, {
        text_key: "published_comments",
        text_ar: "التعليقات المنشورة",
        text_en: "Published Comments"
      }, {
        text_key: "new_comments",
        text_ar: "التعليقات الجديدة",
        text_en: "New Comments "
      }, {
        text_key: "helpDepartments",
        text_ar: " اقسام المساعدة ",
        text_en: " Help Departments"
      }, {
        text_key: "languageTranslations",
        text_ar: "النصوص والترجمة",
        text_en: "Language Translations"
      }, {
        text_key: "suppliersSettings",
        text_ar: " اعدادات الوكلاء ",
        text_en: " Suppliers Settings "
      }, {
        text_key: "driversSettings",
        text_ar: " اعدادات السائقين ",
        text_en: " Drivers Settings "
      }, {
        text_key: "customersSettings",
        text_ar: " اعدادات العملاء ",
        text_en: " Customers Settings "
      }, {
        text_key: "mainSettings",
        text_ar: " الاعدادات الرئيسية ",
        text_en: " Main Settings "
      }, {
        text_key: "dashboardSettings",
        text_ar: " اعدادات لوحة التحكم ",
        text_en: " Dashboard Settings "
      }, {
        text_key: "websiteSettings",
        text_ar: " اعدادات الموقع الالكتروني ",
        text_en: " Website Settings "
      }, {
        text_key: "apiSettings",
        text_ar: " اعدادات Api's ",
        text_en: " Api's Settings "
      }, {
        text_key: "pointsCustomer",
        text_ar: " نقاط العملاء ",
        text_en: " Customers Points "
      }, {
        text_key: "pointsDriver",
        text_ar: " نقاط السائقين ",
        text_en: " Drivers Points "
      }, {
        text_key: "reportingOptions",
        text_ar: "اسباب الابلاغات",
        text_en: "Reporting Options "
      }, {text_key: "lock_screen", text_ar: " إغلاق الشاشة", text_en: " Lock Screen "}, {
        text_key: "profile",
        text_ar: " تحديث بياناتي ",
        text_en: "Update Profile"
      }, {text_key: "map", text_ar: "الخريطة", text_en: "Map"}, {
        text_key: "map_tracking_filter",
        text_ar: "فرز النتائج",
        text_en: " Filter Results "
      }, {text_key: "live_map", text_ar: " خريطة المراقبة ", text_en: " Tracking Map "}, {
        text_key: "select_zone",
        text_ar: "اختر المنطقة",
        text_en: "Select Zone"
      }, {text_key: "show", text_ar: "عرض", text_en: " Show "}, {
        text_key: "entries",
        text_ar: "نتيجة",
        text_en: " entries "
      }, {text_key: "country_id", text_ar: "الدولة", text_en: "Country id"}, {
        text_key: "Showing",
        text_ar: " يعرض ",
        text_en: " Showing "
      }, {text_key: "country_code", text_ar: "رمز الدولة", text_en: " Country Code "}, {
        text_key: "yesDeleteIt",
        text_ar: " نعم احذف",
        text_en: " Yes delete it! "
      }, {text_key: "exportImport", text_ar: "تصدير واستيراد", text_en: "Export & Import"}, {
        text_key: "restore",
        text_ar: "استعادة",
        text_en: " Restore! "
      }, {text_key: "yes_restore_it", text_ar: "نعم ", text_en: " Yes "}, {
        text_key: "restoreConfirm",
        text_ar: " هل انت متأكد من استعادة العنصر المحذوف؟ ",
        text_en: " Are you sure to restore the deleted item? "
      }, {
        text_key: "restored_successfully",
        text_ar: " تمت الاستعادة بنجاخ ",
        text_en: " Item restored Successfully "
      }, {text_key: "success", text_ar: " عملية ناجحة ", text_en: " Successfully "}, {
        text_key: "please_enter",
        text_ar: " فضلا أدخل ",
        text_en: " Please Enter "
      }, {
        text_key: "please_enter_required_inputs",
        text_ar: "فضلا ادخل الحقول المطلوبة اولا ",
        text_en: " Please enter required inputs "
      }, {text_key: "of", text_ar: "من", text_en: "Of"}, {
        text_key: "import",
        text_ar: "إستيراد البيانات",
        text_en: "Import Data "
      }, {text_key: "export", text_ar: "تصدير البيانات ", text_en: " Export Data "}, {
        text_key: "import_note",
        text_ar: " قم بتحميل القالب ثم اضاف البيانات وقم باستيرادها دفعة واحدة ",
        text_en: " Download the template, add the data, and import it in one go "
      }, {
        text_key: "select_file_and_click_upload",
        text_ar: " فضلا اختر ملف الاكسل ثم اضغط على زر استيراد ",
        text_en: " choose excel file and click import Data button "
      }, {
        text_key: "import_note_file",
        text_ar: " يجب عليك الالتزام بتنسيق القالب وعدم تغيير العناوين او اسم الشيت فقط قم بتغيير البيانات ",
        text_en: " You must adhere to the format of the template and not change the addresses or the name of the sheet, just change the data "
      }, {text_key: "downloadFile", text_ar: " تحميل القالب ", text_en: " Download Template "}, {
        text_key: "uploadfile",
        text_ar: " استيراد من ",
        text_en: " Import From "
      }, {text_key: "download", text_ar: " تحميل ", text_en: " Download "}, {
        text_key: "export_note",
        text_ar: "تصدير جميع بيانات الجدول المخزنة بقاعدة البيانات ",
        text_en: " Export all table data stored in the database "
      }, {
        text_key: "export_data_to",
        text_ar: " تصدير البيانات الى ",
        text_en: " export data to "
      }, {
        text_key: "country",
        text_ar: " الدولة ",
        text_en: " Country "
      }, {
        text_key: "click_and_waiting_server_working",
        text_ar: " اضغط على تصدير البيانات وانتظر قليلا حتي يجهز الخادم البيانات ",
        text_en: " Click on Export Data and wait a while for the server to prepare the data "
      }, {text_key: "city_code", text_ar: " معرف جوجل ", text_en: " Google place ID "}, {
        text_key: "lat",
        text_ar: " خط الطول ",
        text_en: " Latitude "
      }, {text_key: "lng", text_ar: " خط العرض ", text_en: " longitude "}, {
        text_key: "old",
        text_ar: " قديم ",
        text_en: " Old "
      }, {text_key: "carMaker", text_ar: " الصانع ", text_en: " Car Maker "}, {
        text_key: "fromModel",
        text_ar: " من موديل",
        text_en: " From Model "
      }, {text_key: "toModel", text_ar: "الى موديل ", text_en: " To Model "}, {
        text_key: "text_en",
        text_ar: " النص بالعربية ",
        text_en: " Text EN "
      }, {text_key: "text_ar", text_ar: " Arabic Text ", text_en: " Text AR "}, {
        text_key: "language",
        text_ar: " الترجمات والنصوص ",
        text_en: " language Text "
      }, {text_key: "text_key", text_ar: " رمز النص", text_en: " Text Key "}, {
        text_key: "lang_for",
        text_ar: " يعمل في ",
        text_en: " Apply on "
      }, {
        text_key: "contactSettings",
        text_ar: " معلومات الاتصال ",
        text_en: " Contact Settings "
      }, {
        text_key: "generalTimeSettings",
        text_ar: " الاعدادات العامة للوقت ",
        text_en: " General Time Settings "
      }, {text_key: "customer", text_ar: " العميل ", text_en: " Customer "}, {
        text_key: "tripDateTime",
        text_ar: " وقت الرحلة ",
        text_en: " Trip Date "
      }, {text_key: "service", text_ar: " الخدمة ", text_en: " Service "}, {
        text_key: "payment_method",
        text_ar: " وسيلة الدفع ",
        text_en: " Payment Method "
      }, {
        text_key: "StaticsByVehicleType",
        text_ar: " احصائيات حسب نوع المركبة ",
        text_en: " Statics By Vehicle Type "
      }, {
        text_key: "StaticsByByZone",
        text_ar: " احصائيات حسب نوع المنطقة",
        text_en: " Statics By Zone "
      }, {text_key: "car_id", text_ar: " المركبة ", text_en: " Car "}, {
        text_key: "StaticsByServiceType",
        text_ar: " احصائيات حسب نوع الخدمة",
        text_en: " Statics By Service Type "
      }, {
        text_key: "tripsLiveMap",
        text_ar: " خريطة حية ",
        text_en: " Trips Live Map "
      }, {
        text_key: "unpublished_comments",
        text_ar: "التعليقات الغير منشورة",
        text_en: "Unpublished Comments"
      }, {
        text_key: "StaticsByCarMaker",
        text_ar: " احصائيات حسب الصانع ",
        text_en: " Statics By Car Maker "
      }, {
        text_key: "StaticsClientCanceled",
        text_ar: " احصائيات الغاء العميل ",
        text_en: " Statics Client Canceled "
      }, {
        text_key: "driverCanceled",
        text_ar: " احصائيات الغاء السائق ",
        text_en: " Driver Canceled "
      }, {
        text_key: "StaticsByVehicleModel",
        text_ar: " احصائيات حسب موديل المركبة ",
        text_en: " Statics By Vehicle Model "
      }, {text_key: "carsModel", text_ar: "موديل المركبة ", text_en: " Car Model "}, {
        text_key: "before_after_arrival",
        text_ar: " قبل وبعد الوصول ",
        text_en: " Before after Arrival "
      }, {text_key: "trip_status", text_ar: " حالة الرحلة ", text_en: " Trip Status "}, {
        text_key: "counter",
        text_ar: " العدد ",
        text_en: " Counter "
      }, {text_key: "canceled_after", text_ar: " الغاء بعد ", text_en: " Canceled_after "}, {
        text_key: "serviceRating",
        text_ar: " تقييم الخدمة ",
        text_en: " Service Rating "
      }, {text_key: "arrivalStatus", text_ar: " حالة الوصول ", text_en: " Arrival Status "}, {
        text_key: "stars",
        text_ar: " نجوم ",
        text_en: " Stars "
      }, {text_key: "ratingCounter", text_ar: " عدد التقييمات ", text_en: " Rating Counter "}, {
        text_key: "average",
        text_ar: " متوسط ",
        text_en: " Average "
      }, {text_key: "VehicleType", text_ar: " نوع المركبة ", text_en: " Vehicle Type "}, {
        text_key: "zone",
        text_ar: " المنطة ",
        text_en: " Zone "
      }, {
        text_key: "liveDataByServiceType",
        text_ar: " بيانات حية حسب نوع الخدمة ",
        text_en: " Live Data By Service Type "
      }, {
        text_key: "customersRating",
        text_ar: " تقييم العملاء ",
        text_en: " Customers Rating "
      }, {
        text_key: "liveDataByZone",
        text_ar: " خريطة حية حسب المنطقة ",
        text_en: " Live Data By Zone "
      }, {
        text_key: "liveDataByVehicleType",
        text_ar: " خريطة حية حسب نوع المركبة ",
        text_en: " Live Data By Vehicle Type "
      }, {
        text_key: "waitingArraival",
        text_ar: " فى انتظار الوصول ",
        text_en: "Waiting Arrival "
      }, {
        text_key: "customerCanceled",
        text_ar: " الغاها العميل ",
        text_en: "Customer Canceled"
      }, {
        text_key: "select_vehicle_type",
        text_ar: " اختر نوع المركبة",
        text_en: " Select vehicle type "
      }, {
        text_key: "select_status",
        text_ar: " اختر الحالة ",
        text_en: " Select Status "
      }, {
        text_key: "customer_mobile_or_pin",
        text_ar: " رقم العميل او رمز الخدمة ",
        text_en: " Customer Mobile or PIN "
      }, {
        text_key: "driver_mobile_or_pin",
        text_ar: " رقم السائق او رمز الخدمة ",
        text_en: " Driver Mobile or PIN "
      }, {
        text_key: "change_password",
        text_ar: " السماح بتغيير كلمة المرور ",
        text_en: " Allow Change Password "
      }, {
        text_key: "max_login_attempted",
        text_ar: " الحد الاقصي لمحاولات الدخول ",
        text_en: " Max Login Attempted "
      }, {
        text_key: "attempted_logi_time_out",
        text_ar: " مدة الحظر المؤقت ",
        text_en: " Attempted time out "
      }, {
        text_key: "delivery_comments",
        text_ar: "تعليقات التوصيل",
        text_en: "Delivery Comments"
      }, {text_key: "reports", text_ar: "البلاغات", text_en: "Reports"}, {
        text_key: "auto_block_ip_affter",
        text_ar: " حظر IP بعد مرات ",
        text_en: " Blocked IP After "
      }, {
        text_key: "restaurant_reports",
        text_ar: "بلاغات المتاجر",
        text_en: "Stores Report"
      }, {text_key: "search_reports", text_ar: "البحث عن بلاغ", text_en: "Report Search"}, {
        text_key: "new_reports",
        text_ar: "إبلاغات جديدة",
        text_en: "New Reports"
      }, {
        text_key: "generalMessage",
        text_ar: " رسالة ثابتة للجميع ",
        text_en: " Static Message on wall "
      }, {
        text_key: "change_pass_first_login",
        text_ar: " تغيير كلمة المرور مع اول دخول ",
        text_en: " Change Password after first Login "
      }, {
        text_key: "driverSettings",
        text_ar: " اعدادات السائق ",
        text_en: " Driver Settings "
      }, {
        text_key: "acceptTimeout",
        text_ar: " وقت القبول ",
        text_en: " Accept Time out "
      }, {
        text_key: "waitingStartDistance",
        text_ar: " انتظار الوصول بعد ",
        text_en: " Waiting Start Distance "
      }, {text_key: "waitingTime", text_ar: " وقت الانتظار ", text_en: " Waiting Time "}, {
        text_key: "freeCancel",
        text_ar: " الغاء مجاني ",
        text_en: " Free Cancel "
      }, {
        text_key: "cancelAfterWaiting",
        text_ar: " المساح بالالغاء بعد ",
        text_en: " Allow Cancel After Waiting "
      }, {
        text_key: "allowCancelBeforArrived",
        text_ar: " المساء بالالغاء قبل الوصول ",
        text_en: " Allow Cancel Before Arrival "
      }, {text_key: "cancelCost", text_ar: " تكلفة الالغاء ", text_en: " Cancel Cost "}, {
        text_key: "timeUnit",
        text_ar: " وحدة الوقت ",
        text_en: " Time Unit "
      }, {text_key: "zone_id", text_ar: " الخدمة ", text_en: " Service "}, {
        text_key: "city_id",
        text_ar: " المدينة ",
        text_en: " City "
      }, {text_key: "place_id", text_ar: " المنطقة ", text_en: " Zone "}, {
        text_key: "searchingTime",
        text_ar: " وقت البحث ",
        text_en: "Searching Time "
      }, {
        text_key: "timeBetweenBlockSearch",
        text_ar: " الوقت بين وحدات البحث ",
        text_en: " Time Between Block Search "
      }, {
        text_key: "locationUpdateEvery",
        text_ar: " تحديث الموقع كل ",
        text_en: " Location update Every "
      }, {
        text_key: "locationUpdateSavedEvery",
        text_ar: "حفظ تحديث الموقع كل ",
        text_en: " Location save update Every "
      }, {
        text_key: "customerCancelActionLabels",
        text_ar: " انواع الغاءات العملاء ",
        text_en: " Customer Cancel Action Labels "
      }, {text_key: "ip_whitelist", text_ar: " القائمة البيضاء ", text_en: " White List "}, {
        text_key: "id_address",
        text_ar: "القائمة السوداء ",
        text_en: " Black List "
      }, {text_key: "label_color", text_ar: " اللون ", text_en: " Color "}, {
        text_key: "allowDriver_signup",
        text_ar: " المساح بتسجيل السائقين",
        text_en: " Allow Drivers Signup "
      }, {
        text_key: "allowSupplier_signup",
        text_ar: " السماح بتسجيل الوكلاء ",
        text_en: " Allow Suppliers Signup "
      }, {
        text_key: "allowClient_signup",
        text_ar: " المساح بتسجيل العملاء ",
        text_en: " Allow Clients Signup "
      }, {text_key: "description_ar", text_ar: " الوصف AR ", text_en: " Description AR "}, {
        text_key: "description_en",
        text_ar: " الوصف EN ",
        text_en: " Description EN "
      }, {
        text_key: "seo_keywords_ar",
        text_ar: " الكلمات البحثية AR ",
        text_en: " SEO Key words AR "
      }, {
        text_key: "seo_keywords_en",
        text_ar: "الكلمات البحثية EN ",
        text_en: " SEO Key words EN "
      }, {
        text_key: "allowForgetPassword",
        text_ar: " استعادة كلمة المرور ",
        text_en: " Allow forget Password "
      }, {
        text_key: "autoLocked",
        text_ar: " قفل تلقائي ",
        text_en: " Auto Lock screen "
      }, {
        text_key: "allowChangePassword",
        text_ar: " السماح بتغيير كلمة المرور ",
        text_en: " Allow Change Password "
      }, {text_key: "websiteUrl", text_ar: " رابط الموقع ", text_en: " Web URL "}, {
        text_key: "commercialID",
        text_ar: " السجل التجاري",
        text_en: " Commercial ID "
      }, {text_key: "vatID", text_ar: " ضريبة قيمة مضافة ", text_en: " VAT ID "}, {
        text_key: "expiringAlertBefore",
        text_ar: " التنبيه قبل الانتهاء ",
        text_en: " Expiring Alert "
      }, {text_key: "drivingLicance", text_ar: " رخصة القيادة ", text_en: "Driving Licence "}, {
        text_key: "carLicance",
        text_ar: " رخصة المركبة",
        text_en: " Car Licence "
      }, {text_key: "carCheck", text_ar: " فحص المركبة ", text_en: " Car check "}, {
        text_key: "api_key",
        text_ar: " Api Key ",
        text_en: " Api Key "
      }, {
        text_key: "app_android_package",
        text_ar: " حزنة Android ",
        text_en: " Android Package "
      }, {text_key: "app_ios_package", text_ar: " حزمة IOS", text_en: " IOS Package "}, {
        text_key: "allowDomains",
        text_ar: " النطاقات المسموح لها ",
        text_en: "Allow Domains "
      }, {text_key: "app_id", text_ar: " App ID ", text_en: " App ID "}, {
        text_key: "socket_server",
        text_ar: " Socket Server ",
        text_en: " Socket Server "
      }, {
        text_key: "socket_server_api_key",
        text_ar: " Socket Server API ",
        text_en: " Socket Server API "
      }, {text_key: "app", text_ar: " التطبيق ", text_en: " App "}, {
        text_key: "big_icon",
        text_ar: " صورة كبيرة ",
        text_en: " Big Icon "
      }, {text_key: "small_icon", text_ar: " صورة صغيرة ", text_en: " Small Icon "}, {
        text_key: "app_key",
        text_ar: " مفتاح API ",
        text_en: " API Key "
      }, {
        text_key: "pointsSettings",
        text_ar: " اعدادات النقاط ",
        text_en: " Points Settings "
      }, {
        text_key: "viewed_reports",
        text_ar: "تم الاطلاع عليها",
        text_en: "Viewed Reports"
      }, {text_key: "serviceZone_id", text_ar: " الخدمة ", text_en: " Service Zone "}, {
        text_key: "important_reports",
        text_ar: "بلاغات هامة",
        text_en: "Important Reports"
      }, {text_key: "delivery_reports", text_ar: "بلاغات التوصيل", text_en: "Delivery Reports"}, {
        text_key: "logout",
        text_ar: "تسجيل خروج",
        text_en: "Logut"
      }, {text_key: "supports", text_ar: "طلبات المساعدة", text_en: "Supports"}, {
        text_key: "clients_supports",
        text_ar: "الدعم الفني للعملاء",
        text_en: "Clients Support"
      }, {text_key: "new_tickets", text_ar: "طلبات جديدة", text_en: "New Tickets"}, {
        text_key: "opened_tickets",
        text_ar: "طلبات مفتوحة",
        text_en: "Opened Tickets"
      }, {text_key: "closed_tickets", text_ar: "طلبات مغلقة", text_en: "Closed Tickets"}, {
        text_key: "expired_tickets",
        text_ar: "طلبات منتهية",
        text_en: "Expired Tickets"
      }, {
        text_key: "stores_supports",
        text_ar: "الدعم الفني للمتاجر",
        text_en: "Stores Support"
      }, {
        text_key: "delivery_supports",
        text_ar: "الدعم الفني للتوصيل",
        text_en: "Delivery Support"
      }, {text_key: "clients", text_ar: "العملاء", text_en: "Clients"}, {
        text_key: "clients_search",
        text_ar: "البحث",
        text_en: "Search"
      }, {text_key: "main_report", text_ar: "تقرير عام", text_en: "Full Report"}, {
        text_key: "all",
        text_ar: "الجميع",
        text_en: "All"
      }, {text_key: "join7days", text_ar: "انضم اخر ٧ أيام", text_en: "Join Last 7 Days"}, {
        text_key: "join30days",
        text_ar: "انضم اخر ٣٠ أيام",
        text_en: "Join Last 30 Days"
      }, {text_key: "topOrders", text_ar: "الاكثر طلبات", text_en: "Top orders"}, {
        text_key: "blocked",
        text_ar: "محظور",
        text_en: "Blocked"
      }, {text_key: "deliversMan", text_ar: "التوصيل", text_en: "Delivery Users"}, {
        text_key: "waitingApproved",
        text_ar: "فى انتظار الموافقة",
        text_en: "Waiting Approved"
      }, {text_key: "search", text_ar: "البحث", text_en: "Search"}, {
        text_key: "lowOrders",
        text_ar: "الاقل طلبا",
        text_en: "Low Orders"
      }, {text_key: "highRating", text_ar: "الاعلي تقييما", text_en: "High Rating"}, {
        text_key: "lowRating",
        text_ar: "الأقل تقييما",
        text_en: "Low Rating"
      }, {text_key: "topReports", text_ar: "الاكثر إبلاغ", text_en: "Top Reports"}, {
        text_key: "lowBalance",
        text_ar: "مديونية",
        text_en: "Low Balance"
      }, {text_key: "finance", text_ar: "النظام المالي ", text_en: "Finance"}, {
        text_key: "storesDepartments",
        text_ar: "الاقسام والتصنيفات",
        text_en: "Departments "
      }, {text_key: "stores", text_ar: "المتاجر", text_en: "Stores"}, {
        text_key: "walletTransactions",
        text_ar: "عمليات المحفظة",
        text_en: "Wallet Transactions"
      }, {
        text_key: "cardTransactions",
        text_ar: "عمليات بالبطاقة",
        text_en: "Card Transactions"
      }, {
        text_key: "promoCodesTransactions",
        text_ar: "استخدامات القسائم",
        text_en: "Used Promo codes "
      }, {
        text_key: "cashTransactions",
        text_ar: "العمليات النقدية",
        text_en: "Cash Transactions"
      }, {text_key: "balance", text_ar: "الوضع المالي ", text_en: "Balance"}, {
        text_key: "deliveryMan",
        text_ar: "التوصيل",
        text_en: "Delivery Users"
      }, {
        text_key: "incomingClaims",
        text_ar: "الفواتير الغير مسددة",
        text_en: "Payin "
      }, {text_key: "bonusTransactions", text_ar: "العمولات", text_en: "Bonos"}, {
        text_key: "outComingClaims",
        text_ar: "الفواتير المستحقة",
        text_en: "payout"
      }, {text_key: "profitsSystem", text_ar: "نظام الارباح", text_en: "Profits System"}, {
        text_key: "storesSettings",
        text_ar: "المتاجر",
        text_en: "Stores"
      }, {
        text_key: "storesProfitsPlan",
        text_ar: "خطط ارباح المتاجر",
        text_en: "Stores Profits Plan"
      }, {
        text_key: "deliverySettings",
        text_ar: "التوصيل",
        text_en: "Delivery Settings"
      }, {
        text_key: "deliveryProfitsPlan",
        text_ar: "خطة ارباح التوصيل",
        text_en: "Delivery Profit Plan"
      }, {text_key: "transactions", text_ar: "العمليات", text_en: "Transactions"}, {
        text_key: "profitReport",
        text_ar: "تقرير الارباح",
        text_en: "Profit Report"
      }, {
        text_key: "profitFollowChart",
        text_ar: "معدل تصاعد الارباح",
        text_en: "Profit Follow Chart"
      }, {text_key: "profitLost", text_ar: "الارباح والخسائر", text_en: "Profit Lost"}, {
        text_key: "fullReports",
        text_ar: "تقرير شامل",
        text_en: "Full Report"
      }, {text_key: "fullReport", text_ar: "تقرير شامل", text_en: "Full Report"}, {
        text_key: "staticPages",
        text_ar: "الصفحات الثابتة",
        text_en: "Static Pages"
      }, {text_key: "add_new", text_ar: "إضافة جديد", text_en: "Add New "}, {
        text_key: "admins",
        text_ar: "المديرين",
        text_en: "Admins"
      }, {text_key: "rolls", text_ar: "الصلاحيات", text_en: "Rolls"}, {
        text_key: "actionsHistory",
        text_ar: "سجل الاوامر",
        text_en: "Actions History"
      }, {
        text_key: "automatedSystem",
        text_ar: "النظام الذاتي ",
        text_en: "Automated System"
      }, {
        text_key: "marketingAuto",
        text_ar: "التسويق الذاتي",
        text_en: "ِAuto Marketing "
      }, {
        text_key: "autoDeliveryOffers",
        text_ar: "العروض الذاتية للتوصيل",
        text_en: "Auto Delivery Offers"
      }, {
        text_key: "supportAutoOperations",
        text_ar: "الردود الاليه للدعم الفني ",
        text_en: "Support Auto Operations"
      }, {text_key: "settings", text_ar: "الاعدادات", text_en: "Settings"}, {
        text_key: "mainSettings",
        text_ar: "الاعدادات العامة",
        text_en: "Main Settings"
      }, {
        text_key: "autoNotifications",
        text_ar: "الاشعارات التلقائية",
        text_en: "Auto Notifications"
      }, {
        text_key: "locations",
        text_ar: "الدول والمحافظات",
        text_en: "Countries & cities "
      }, {text_key: "workLocations", text_ar: "نطاقات العمل", text_en: "Work Locations "}, {
        text_key: "termsOfuse",
        text_ar: "شروط الاستتخدام",
        text_en: "Term of Use"
      }, {text_key: "policy", text_ar: "الخصوصية", text_en: "Policy"}, {
        text_key: "refundTerms",
        text_ar: "شروط الارجاع",
        text_en: "Term of Refund "
      }, {
        text_key: "smsTemplates",
        text_ar: "محتوي الرسائل النصية",
        text_en: "SMS Template "
      }, {
        text_key: "emailTemplates",
        text_ar: "محتوي رسائل البريد",
        text_en: "Email Templates"
      }, {
        text_key: "notificationsTemplates",
        text_ar: "محتوي الاشعارات",
        text_en: "Notification Template"
      }, {
        text_key: "supportTicketsDepartments",
        text_ar: "اقسام الدعم الفني ",
        text_en: "Support Departments "
      }, {text_key: "promoCodes", text_ar: "العروض الترويجية", text_en: "Promo Codes"}, {
        text_key: "new",
        text_ar: "جديد",
        text_en: "New"
      }, {text_key: "used", text_ar: "مستخدم", text_en: "Used"}, {
        text_key: "notUsed",
        text_ar: "غير مستخدم",
        text_en: "Not Used"
      }, {text_key: "usedHistory", text_ar: "سجل الاستخدام", text_en: "Used History"}, {
        text_key: "orderDate",
        text_ar: "تاريخ الطلب",
        text_en: "Order Date"
      }, {text_key: "clientID", text_ar: "العميل", text_en: "Client"}, {
        text_key: "view_results",
        text_ar: "عرض النتائج",
        text_en: "View Results"
      }, {text_key: "orderNo", text_ar: "رقم الطلب ", text_en: "Order No"}, {
        text_key: "search_results",
        text_ar: "نتيجة البحث",
        text_en: "Search Results"
      }, {text_key: "storeID", text_ar: "المتجر", text_en: "Store"}, {
        text_key: "orderStatus",
        text_ar: "حالة الطلب",
        text_en: "Order Status"
      }, {text_key: "deliveryFee", text_ar: "قمية التوصيل", text_en: "Delivery Fee"}, {
        text_key: "discount",
        text_ar: "خصم",
        text_en: "Discount"
      }, {text_key: "total", text_ar: "إجمالي الطلب", text_en: "Total"}, {
        text_key: "orderDetails",
        text_ar: " الطلب ",
        text_en: "Order "
      }, {text_key: "commentDate", text_ar: "تاريخ التعليق", text_en: "Comment Date"}, {
        text_key: "sub_total",
        text_ar: "الاجمالي",
        text_en: "Sub Total"
      }, {
        text_key: "deliveryManName",
        text_ar: "اسم عامل التوصيل",
        text_en: "Delivery Man Name"
      }, {
        text_key: "comment_search_results",
        text_ar: "نتيجة البحث عن تلعيقات",
        text_en: "Comment Search Results "
      }, {text_key: "rating", text_ar: "التقييم", text_en: "Rating"}, {
        text_key: "createDate",
        text_ar: "تاريخ الاضافة",
        text_en: "Create Date"
      }, {text_key: "moreDetails", text_ar: "المزيد من التفاصيل", text_en: "More Details "}, {
        text_key: "reportDate",
        text_ar: "تاريخ الابلاغ",
        text_en: "Report Date"
      }, {text_key: "reportType", text_ar: "نوع الابلاغ", text_en: "Report Type"}, {
        text_key: "ticketNo",
        text_ar: "الرقم المرجعي",
        text_en: "Reference No"
      }, {text_key: "supportDepartment", text_ar: "القسم", text_en: "Department"}, {
        text_key: "lastReplay",
        text_ar: "أخر رد",
        text_en: "Last Replay"
      }, {text_key: "ticketStatus", text_ar: "الحالة", text_en: "Status"}, {
        text_key: "new_client",
        text_ar: "عميل جديد",
        text_en: "New Client"
      }, {text_key: "clients_all", text_ar: "جميع العملاء", text_en: "Clients ALl"}, {
        text_key: "clients_join7days",
        text_ar: "انضم أخر ٧ ايام",
        text_en: "clients Join last 7 Days"
      }, {
        text_key: "clients_main_report",
        text_ar: "تقرير عام العملاء",
        text_en: "Clients Main Report "
      }, {
        text_key: "clients_join30days",
        text_ar: "علاء انضموا اخر ٣٠ يوم",
        text_en: "Clients Join 30 Days"
      }, {
        text_key: "clients_topOrders",
        text_ar: "العملاء الاكثر طلبات",
        text_en: "Clients Top Orders "
      }, {
        text_key: "clients_blocked",
        text_ar: "علاء تم حظرهم",
        text_en: "Blocked Clients "
      }, {text_key: "deliversManAll", text_ar: "الجميع", text_en: "All"}, {
        text_key: "name_ar",
        text_ar: "الاسم AR",
        text_en: "Name AR"
      }, {text_key: "name_en", text_ar: "الاسم EN", text_en: "Name EN"}, {
        text_key: "photo",
        text_ar: "الصورة",
        text_en: "Photo"
      }, {text_key: "sort", text_ar: "الترتيب", text_en: "Sort"}, {
        text_key: "addNewDepartment",
        text_ar: "اضافة تصنيف جديد",
        text_en: "Add New Department"
      }, {text_key: "tools", text_ar: "الادوات", text_en: "Tools"}, {
        text_key: "add_edit",
        text_ar: "إضافة وتعديل",
        text_en: "Add Edit"
      }, {text_key: "save_new", text_ar: "حفظ جديد", text_en: "Save New"}, {
        text_key: "back",
        text_ar: "العودة",
        text_en: "Back"
      },
      {text_key: "citiesList", text_ar: "المدن", text_en: "Cities "},
      {text_key: "contract_exp_date", text_ar: "تاريخ انتهاء العقد", text_en: "Contract Expired Date"},
      {text_key: "confirmation_section", text_ar: "التحقق والموافقة", text_en: "Confirmation Section "},
      {text_key: "correct_info", text_ar: "بيانات صحيحة", text_en: "Correct Information "},
      {text_key: "id_exp_date", text_ar: "انتهاء الهوية", text_en: "ID Exp Date "},
      {text_key: "sataRaid", text_ar: "رايد", text_en: "Raid"},
      {text_key: "sataRent", text_ar: "رينت", text_en: "Rent"},
      {text_key: "approved", text_ar: "موافقة", text_en: "Approved"},
      {text_key: "reason", text_ar: "السبب", text_en: "Reason"},
      {text_key: "reason_note", text_ar: "ادخل السبب فى حالة الرفض", text_en: "Enter Reason if Rejected "},
      {text_key: "wronginfo", text_ar: "معلومات غير صحيحة", text_en: "Wrong info"},
      {text_key:"socialmedia",text_ar: "الشبكات الاجتماعية", text_en: "Social Media"},
      {text_key:"exportImport",text_ar: "إستيراد وتصدير البيانات", text_en: "Export Import Data "},
      {text_key:"no_data_to_export",text_ar: "لا يوجد أي بيانات للتصدير", text_en: "No have any data to export "},
      {text_key:"import_note_2",text_ar: "الحقل الذي يتحتوي على كلمة empty يجب تركة فارغاً", text_en: "The field containing the word empty must be left blank"},
      {text_key:"export_importing_log",text_ar: "تنزيل تقرير الاستيراد", text_en: "Download Importing Log"},
      {text_key:"mac_address",text_ar: " Mac Address", text_en: " Mac Address"},
      {text_key:"wifi_mac_address",text_ar: "WIFI Mac Address", text_en: "WIFI Mac Address"},
      {text_key:"bluetooth_mac_address",text_ar: "Bt Mac Address", text_en: "Bt Mac Address"},
      {text_key:"imi_1",text_ar: "IMI1", text_en: "IMI 1"},
      {text_key:"imi_2",text_ar: "IMI2", text_en: "IMI 2"},
      {text_key:"device_serial",text_ar: "معرف الجهاز", text_en: "Device Serial"},
      {text_key:"sd_serial",text_ar: "معرف بطاقة الذاكرة", text_en: "SD Serial"},
      {text_key:"min_driver",text_ar: "الحد الادني للسائق", text_en: "Min Driver "},
      {text_key:"min_customer",text_ar: "الحد الادني للعمي ل", text_en: "Min Customer"},
      {text_key:"cancel_driver_cost",text_ar: "تكلفة الغاء السائق", text_en: "Cancel Driver Cost"},
      {text_key:"cancel_customer_cost",text_ar: "تكلفة الغاء العميل ", text_en: "Cancel Customer Cost"},
      {text_key:"skipLock",text_ar: "تخطي قفل الشاشة", text_en: "Skip Lock"},
      {text_key:"table_name",text_ar: "جدول  DB  ", text_en: "Table Name"},
      {text_key:"path_log",text_ar: "Api Path", text_en: "Path Log"},
      {text_key:"path_action",text_ar: "الاجراء", text_en: "Action"},
      {text_key:"log_ip_address",text_ar: "IP Address ", text_en: "IP Address "},
      {text_key:"share",text_ar: "مشاركة", text_en: "Share"},
      {text_key:"comments",text_ar: "التعليقات", text_en: "Comments"},
      {text_key:"videos",text_ar: "الفيديوهات", text_en: "Videos"},
      {text_key:"users",text_ar: "المستخدمين", text_en: "users"},
      {text_key:"app_numbers",text_ar: "معدل النمو", text_en: "Gnrowth rate"},
      {text_key:"top_viewed",text_ar: "الأكثر مشاهدة", text_en: "Top Viewed"},
      {text_key:"new_videos",text_ar: "الفيدوهات الجديدة", text_en: "New Videos"},
      {text_key:"reported_videos",text_ar: "مبلغ عنها", text_en: "Reported Videos"},
      {text_key:"vp",text_ar: "طلبات التوثيق", text_en: "verification profile"},
      {text_key:"reported",text_ar: "بلاغات", text_en: "Reported"},
      {text_key:"top_hashtag",text_ar: "الاكثر تداولا", text_en: "Top hashtag"},
      {text_key:"new_hashtag",text_ar: "المتداول حديثا", text_en: "New hashtag"},
      {text_key:"emojis_categories",text_ar: "اقسام الايموجي", text_en: "Emojis Categories"},
      {text_key:"emojis",text_ar: "الايموجي", text_en: "Emojis"},
      {text_key:"stickers",text_ar: "الملصقات", text_en: "Stickers"},
      {text_key:"reasons",text_ar: "الاسباب", text_en: "Reasons"},
      {text_key:"verification_profile_requests",text_ar: "طلبات التوثيق", text_en: "verification  Request"},
      {text_key:"chat_list",text_ar: "قائمة المحادثات", text_en: "Chat List"},
      {text_key:"pages",text_ar: "صفحات ثابتة", text_en: "Pages"},
      {text_key:"notifications",text_ar: "الاشعارات", text_en: "Notifications"},
      {text_key:"settings",text_ar: "الاعدادات", text_en: "Settings"},
      {text_key:"categories",text_ar: "التصنيفات", text_en: "Categories"},
      {text_key:"hash_tag",text_ar: "الهاشتاقات", text_en: "Hashtag"},
      {text_key:"confirmed",text_ar: "مؤكد", text_en: "Confirmed"},
      {text_key:"comment_filter",text_en: "Comment word filter", text_ar: "حظر كلمات التعليقات"},
      {text_key:"comments_filter",text_en: "Comment word filter", text_ar: "حظر كلمات التعليقات"},
      {text_key:"video_content_filter",text_en: "Video name filter ", text_ar: "حظر كلمات فيديو"},
      {text_key:"all_categories",text_ar: "جميع التصنيفات", text_en: "All Categories"},
      {text_key:"category",text_ar: "التصنيف", text_en: "Category"},
      {text_key:"user_id",text_ar: "المستخدم", text_en: "user"},
      {text_key:"title",text_ar: "العنوان", text_en: "Title"},
      {text_key:"description",text_ar: "الوصف", text_en: "Description"},
      {text_key:"tags",text_ar: "#هاشتاق", text_en: "#tag"},
      {text_key:"video_type",text_ar: "نوع الفيديو", text_en: "video type"},
      {text_key:"video",text_ar: "الفيديو", text_en: "Video"},
      {text_key:"video_top",text_ar: "جعلة فى الاعلي", text_en: "in top"},
      {text_key:"private",text_ar: "فيديو خاص", text_en: "Private"},
      {text_key:"star_video",text_en: "Star video", text_ar: "فيديو مميز"},
      {text_key:"videos",text_ar: "الفيديوهات", text_en: "Videos"},
      {text_key:"add_new",text_ar: "إضافة جديد", text_en: "Add New"},
      {text_key:"all_users",text_ar: "جميع المستخدمين", text_en: "All users"},
      {text_key:"name",text_ar: "الاسم", text_en: "Name"},
      {text_key:"actions",text_ar: "الاجراءت", text_en: "Actions"},
      {text_key:"mobile",text_ar: "رقم الجوال", text_en: "Mobile"},
      {text_key:"gender",text_ar: "النوع", text_en: "Gender"},
      {text_key:"user_name",text_ar: "اسم المستخدم", text_en: "User name"},
      {text_key:"verified_account",text_ar: "حساب موثق", text_en: "verified account"},
      {text_key:"save",text_ar: "حفظ", text_en: "Save"},
      {text_key:"id_front",text_ar: "الهوية من الامام", text_en: "id front"},
      {text_key:"id_back",text_ar: "الهوية من الخلف", text_en: "id Back"},
      {text_key:"icon",text_ar: "الصورة الرمزية", text_en: "Icon"},
      {text_key:"cover",text_ar: "الغلاف", text_en: "Cover"},
      {text_key:"welcome",text_ar: "مرحبا", text_en: "Welcome"},
      {text_key:"dashboard",text_ar: "لوحة التحكم", text_en: "Dashboard"},
      {text_key:"category_id",text_ar: "التصنيف", text_en: "category"},
      {text_key:"to",text_ar: "الي", text_en: "To"},
      {text_key:"comment",text_ar: "التعليق", text_en: "Comment"},
      {text_key:"view_result",text_ar: "عرض النتائج", text_en: "view results"},
      {text_key:"content_ar",text_ar: "المحتوي بالعربية", text_en: "content AR"},
      {text_key:"content_en",text_ar: "المحتوي بالانجليزية", text_en: "content EN"},
      {text_key:"send",text_ar: "ارسال", text_en: "Send"},
      {text_key:"history",text_ar: "السجل  ", text_en: "History"},
      {text_key:"keyword",text_ar: "الكلمة", text_en: "keyword"},
      {text_key:"delete",text_ar: "حذف", text_en: "delete"},
      {text_key:"deleteConfirm",text_ar: "هل أنت متأكد من الحذف؟", text_en: "Are you sure delete this item?"},
      {text_key:"chat",text_ar: "المحادثة", text_en: "Chat"},
      {text_key:"welcome_text",text_ar: "نمتمني لكم يوم جيد", text_en: "Have nice day "},
      {text_key:"Password",text_ar: "كلمة المرور", text_en: "Password"},
      {text_key:"Remember_me",text_ar: "تذكرني", text_en: "Remember me"},
      {text_key:"change_lang",text_ar: "تغيير اللغة", text_en: "Change Language"},
      {text_key:"company_name",text_ar: "Reekoo", text_en: "Reekoo"},
      {text_key:"copy_rights",text_ar: "جميع الحقوق محفوظة", text_en: ""},
      {text_key:"video_reports",text_ar: "ابلاغ الفيديوهات", text_en: "Video Reports"},
      {text_key:"accounts_reports",text_ar: "ابلاغ الحسابات", text_en: "Accounts Reports"},
      {text_key:"seen",text_ar: "تم النظر", text_en: "Seen"},
      {text_key:"users_level",text_ar: "مجموعات المستخدمين", text_en: "Users Group"},
      {text_key:"chat_settings",text_ar: "اعدادات المحادثة", text_en: "Chat Settings"},
      {text_key:"video_settings",text_ar: "إعدادات الفيديو", text_en: "Video Settings"},
      {text_key:"video_duration",text_ar: "مدة الفيديو", text_en: "video duration"},
      {text_key:"video_edit",text_ar: "محرر الفيديو", text_en: "Video Editor"},
      {text_key:"video_from_cam",text_ar: "التقاط فيديو", text_en: "Video From cam"},
      {text_key:"video_from_gallery",text_ar: "فيديو من المعرض", text_en: "video from gallery"},
      {text_key:"sond_only",text_ar: "الصوت", text_en: "Sound"},
      {text_key:"level_id",text_ar: "مجموعة المستخدمين", text_en: "Users Group"},
      {text_key:"voice",text_ar: "ارسل صوت", text_en: "Send Voice"},
      {text_key:"image",text_ar: "ارسال صورة", text_en: "Send Image"},
      {text_key:"document",text_ar: "ارسال مستندات", text_en: "Send Document"},
      {text_key:"location",text_ar: "ارسال موقع", text_en: "Send Location "},
      {text_key:"comments_reports",text_ar: "إبلاغ التعليقات", text_en: "Comments Reports"},
      {text_key:"Edit",text_ar: "تعديل", text_en: "Edit"},
      {text_key:"sound",text_ar: "الصوت", text_en: "Sound"},
      {text_key:"save_update",text_ar: "حفظ التغييرات", text_en: "Save Update "},
      {text_key:"user",text_ar: "المستخدم", text_en: "User"},
      {text_key:"select",text_ar: "اختر", text_en: "Select"},
      {text_key:"yes",text_ar: "نعم", text_en: "Yes"},
      {text_key:"no",text_ar: "لا", text_en: "No"},
      {text_key:"admins_levels",text_ar: "مستويات الادارة", text_en: "Admins Levels"},
      {text_key:"adminslog",text_ar: "سجل الاجراءات", text_en: "Admins Log"},
      {text_key:"admins_log",text_ar: "سجل الاجراءات", text_en: "Admins Log"},
      {text_key:"today",text_ar: "اليوم", text_en: "Today"},
      {text_key:"home_settings",text_ar: "اعدادات الرئيسية", text_en: "Home Settings "},
      {text_key:"update",text_ar: "تحديث", text_en: "Update"},
      {text_key:"alg_videos",text_ar: "فيديوهات الرئيسية", text_en: "Home Videos  "},
      {text_key:"no_of_vidoes_loaded",text_ar: "عدد الفيديوهات بالرئيسية", text_en: "No of videos at home"},
      {text_key:"admins_access",text_ar: "صلاحيات الوصول", text_en: "Admins Access "},
      {text_key:"add",text_ar: "إضافة", text_en: "Add"},
      {text_key:"edit",text_ar: "تعديل", text_en: "Edit"},
      {text_key:"admins_level",text_ar: "مستوي الوصول", text_en: "Admin level"},
      {text_key:"path",text_ar: "مسار الصفحة ", text_en: "URL : Path"},
      {text_key:"user_lang",text_ar: "اللغة الافتراضية", text_en: "Dashboard Language"},
      {text_key:"user_photo",text_ar: 'الصورة', text_en: "Photo"},
      {text_key:"view_ads",text_ar: "عرض الاعلانات", text_en: "View ads"},
      {text_key:"user_level",text_ar: "مجموعة المستخدم", text_en: "User Group"},
      {text_key:"sec",text_ar: "ثانية", text_en: "Second"},
      {text_key:"permissions",text_ar: "الصلاحيات", text_en: "Permissions"},
      {text_key:"action",text_ar: "الاجراء", text_en: "Action"},
      {text_key:"time",text_ar: "الوقت", text_en: "Time"},
      {text_key:"reporter",text_ar: "المبلغ", text_en: "Reporter"},
      {text_key:"reportd_account",text_ar: "الحساب المبلغ عنه", text_en: "Reportd account"},
      {text_key:"myVideos",text_ar: "فيديوهاتي", text_en: "My Videos"},
      {text_key:"upload",text_ar: "رفع", text_en: "Upload"},
      {text_key:"comment_id",text_ar: "التعليق", text_en: "Comment"},
      {text_key:"unpublished_selected",text_ar: "الغاء نشر المحدد", text_en: "Unpublished selected"},
      {text_key:"published_selected",text_ar: "نشر المحدد", text_en: "Published selected"},
      {text_key:"move_selected",text_ar: "نقل المحدد", text_en: "Move selected"},
      {text_key:"delete_selected",text_ar: "حذف المحدد", text_en: "Delete selected"},
      {text_key:"account_id",text_ar: "الحساب", text_en: "Account"},
      {text_key:"video_id",text_ar: "الفيديو", text_en: "Video "},
      {text_key:"all_video_reports",text_ar: "جميع الفيديوهات المبلغ عنها", text_en: "All Videos Reports "},
      {text_key:"addMulti",text_ar: "اضافة متعددة", text_en: "Add Multi"},
      {text_key:"email_place_holder",text_ar: "البريد الالكتروني", text_en: "Email"},
      {text_key:"pass_login_place_holder",text_ar: "كلمة المرور ", text_en: "Password"},
      {text_key:"uploading",text_ar: "جاري تحميل ....", text_en: "Uploading...."},
      {text_key:"uploaded",text_ar: "اكتمل التحميل", text_en: "uploaded"},
      {text_key:"status",text_ar: "الحالة", text_en: "Status"},
      {text_key:"projectName",text_ar: "اسم المشروع", text_en: "Project Name"},
      {text_key:"accepted",text_ar: "مقبول", text_en: "Accepted"},
      {text_key:"waiting",text_ar: "إنتظار", text_en: "Waiting"},
      {text_key:"addMultiNone",text_ar: "رفع غير معنون", text_en: "Add None Videos"},
      {text_key:"uploadTitle",text_ar: "رفع بعنوان", text_en: "Upload final"},
      {text_key:"script",text_ar: "الحوار", text_en: "script"},
      {text_key:"waitingrename",text_ar: "بانتظار التسمية", text_en: "waiting rename"},
      {text_key:"rename",text_ar: "إعادة التسمية", text_en: "Rename"},
      {text_key:"waitingNoName",text_ar: "انتظار التسمية", text_en: "waiting Name"},
      {text_key:"",text_ar: "", text_en: ""},
    ];
//
  }

}

